
export default function ProcessShowcase() {
  const processSteps = [
    {
      step: '01',
      title: 'Digital Design',
      description: 'Every model begins as a digital concept, carefully crafted using advanced 3D modeling software with precision and attention to detail.',
      image: 'https://public.readdy.ai/ai/img_res/a4001f490419c70995b567059a182573.jpg',
      icon: 'ri-pencil-ruler-2-line'
    },
    {
      step: '02',
      title: 'Pre-Print Preparation',
      description: 'Models are optimized for printing with support structures, layer height calculations, and material selection to ensure perfect results.',
      image: 'https://readdy.ai/api/search-image?query=3D%20printing%20slicer%20software%20showing%20model%20with%20support%20structures%20and%20layer%20preview%2C%20technical%20preparation%20interface%20with%20printing%20parameters%2C%20professional%203D%20printing%20workflow%20setup&width=600&height=400&seq=prep-process&orientation=landscape',
      icon: 'ri-settings-3-line'
    },
    {
      step: '03',
      title: 'Precision Printing',
      description: 'State-of-the-art 3D printers bring digital designs to life layer by layer, with real-time monitoring for quality assurance.',
      image: 'https://readdy.ai/api/search-image?query=High-end%203D%20printer%20in%20action%20creating%20detailed%20model%2C%20layer%20by%20layer%20printing%20process%20visible%2C%20professional%20manufacturing%20environment%20with%20clean%20lighting%2C%20precision%20engineering%20equipment&width=600&height=400&seq=print-process&orientation=landscape',
      icon: 'ri-printer-line'
    },
    {
      step: '04',
      title: 'Post-Processing',
      description: 'Each printed model undergoes careful post-processing including support removal, surface finishing, and quality inspection.',
      image: 'https://readdy.ai/api/search-image?query=Post-processing%20workstation%20with%203D%20printed%20models%20being%20finished%2C%20tools%20for%20support%20removal%20and%20surface%20smoothing%2C%20quality%20control%20inspection%20area%20with%20magnifying%20equipment&width=600&height=400&seq=finish-process&orientation=landscape',
      icon: 'ri-brush-line'
    },
    {
      step: '05',
      title: 'Quality Control',
      description: 'Every model passes through rigorous quality checks to ensure it meets our high standards before reaching customers.',
      image: 'https://readdy.ai/api/search-image?query=Quality%20control%20inspection%20of%20finished%203D%20printed%20models%2C%20precision%20measuring%20tools%20and%20magnification%20equipment%2C%20professional%20quality%20assurance%20workspace%20with%20good%20lighting&width=600&height=400&seq=quality-process&orientation=landscape',
      icon: 'ri-shield-check-line'
    },
    {
      step: '06',
      title: 'Final Product',
      description: 'The completed model represents the perfect fusion of digital innovation and physical craftsmanship, ready for delivery.',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20finished%203D%20printed%20models%20displayed%20on%20clean%20white%20surface%2C%20professional%20product%20photography%20showing%20fine%20details%20and%20surface%20quality%2C%20various%20completed%20models%20showcasing%20craftsmanship&width=600&height=400&seq=final-process&orientation=landscape',
      icon: 'ri-gift-line'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">The Complete Journey</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Follow each model's transformation from digital concept to physical masterpiece. 
            Our meticulous process ensures every detail is preserved and perfected.
          </p>
        </div>

        <div className="space-y-16">
          {processSteps.map((process, index) => (
            <div key={index} className={`flex flex-col lg:flex-row items-center gap-12 ${
              index % 2 === 1 ? 'lg:flex-row-reverse' : ''
            }`}>
              <div className="flex-1">
                <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                  <img
                    src={process.image}
                    alt={process.title}
                    className="w-full h-80 object-cover"
                  />
                </div>
              </div>
              
              <div className="flex-1 space-y-6">
                <div className="flex items-center gap-4">
                  <div className="w-16 h-16 flex items-center justify-center bg-[#0069a5] text-white rounded-full text-2xl font-bold">
                    {process.step}
                  </div>
                  <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full">
                    <i className={`${process.icon} text-2xl text-[#0069a5]`}></i>
                  </div>
                </div>
                
                <h3 className="text-3xl font-bold text-gray-900">{process.title}</h3>
                <p className="text-lg text-gray-600 leading-relaxed">{process.description}</p>
                
                <button className="bg-[#0069a5] hover:bg-[#005a8f] text-white px-6 py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer">
                  Learn More
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
